import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "tint" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Vector",
    d: "M7 21C5.93913 21 4.92172 20.5786 4.17157 19.8284C3.42143 19.0783 3 18.0609 3 17V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9C9.53043 3 10.0391 3.21071 10.4142 3.58579C10.7893 3.96086 11 4.46957 11 5V17C11 18.0609 10.5786 19.0783 9.82843 19.8284M7 21C8.06087 21 9.07828 20.5786 9.82843 19.8284M7 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V15C21 14.4696 20.7893 13.9609 20.4142 13.5858C20.0391 13.2107 19.5304 13 19 13H16.657M9.82843 19.8284L18.314 11.343C18.6889 10.9679 18.8996 10.4593 18.8996 9.929C18.8996 9.39867 18.6889 8.89006 18.314 8.515L15.485 5.686C15.1099 5.31106 14.6013 5.10043 14.071 5.10043C13.5407 5.10043 13.0321 5.31106 12.657 5.686L11 7.343M7 17H7.01",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }